// src/components/SessionCard.tsx
// Active session display card.

import { cn } from '@core/ui';
import { Button } from '@react/components';

interface SessionCardProps {
  device: string;
  browser: string;
  os: string;
  ip: string;
  location?: string;
  lastActive: string;
  isCurrent?: boolean;
  onRevoke?: () => void;
  revokeLabel?: string;
  currentLabel?: string;
  className?: string;
}

export function SessionCard({
  device,
  browser,
  os,
  ip,
  location,
  lastActive,
  isCurrent,
  onRevoke,
  revokeLabel = 'Revoke',
  currentLabel = 'Current session',
  className,
}: SessionCardProps) {
  const deviceIcon = device === 'Mobile' ? (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z" />
    </svg>
  ) : (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
    </svg>
  );

  return (
    <div className={cn('p-4 rounded-lg border', isCurrent ? 'border-primary bg-primary/5' : 'border-border bg-card', className)}>
      <div className="flex items-start justify-between gap-3">
        <div className="flex items-start gap-3">
          <div className="p-2 rounded-lg bg-muted text-muted-foreground">
            {deviceIcon}
          </div>
          <div>
            <div className="text-sm font-medium text-foreground">
              {browser} on {os}
            </div>
            <div className="text-xs text-muted-foreground mt-0.5">
              {ip}{location ? ` — ${location}` : ''}
            </div>
            <div className="text-xs text-muted-foreground mt-0.5">
              {lastActive}
            </div>
          </div>
        </div>
        <div className="shrink-0">
          {isCurrent ? (
            <span className="text-xs font-medium text-primary">{currentLabel}</span>
          ) : onRevoke ? (
            <Button variant="ghost" size="sm" onClick={onRevoke}>{revokeLabel}</Button>
          ) : null}
        </div>
      </div>
    </div>
  );
}
